<template>
  <div class="col-10 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <div class="row">
          <div class="col-6">
            <form class="needs-validation" @submit.prevent="save">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Nombre (*) </label>

                    <el-input
                      v-model="formData.name"
                      v-validate="modelValidations.name"
                      name="name"
                      placeholder="Nombre"
                    >
                    </el-input>

                    <small v-show="name.invalid" class="text-danger">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>

                <div v-if="!editMode" class="col-sm-12">
                  <div class="form-group">
                    <producer-select
                      v-model="formData.producer"
                      v-validate="modelValidations.producer"
                      :filter-by-distributor="false"
                      name="producer"
                      placeholder="Seleccione Productor"
                    />
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Hectareas (*) </label>

                    <el-input
                      v-model="formData.hectares"
                      v-validate="modelValidations.hectares"
                      name="hectares"
                      placeholder="Hectareas"
                    >
                    </el-input>

                    <small v-show="hectares.invalid" class="text-danger">
                      {{ getError('hectares') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Dirección (*) </label>

                    <el-input
                      v-model="formData.address"
                      v-validate="modelValidations.address"
                      name="address"
                      placeholder="Dirección"
                    >
                    </el-input>

                    <small v-show="address.invalid" class="text-danger">
                      {{ getError('address') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Provincia (*) </label>

                    <el-select
                      v-model="formData.province"
                      v-validate="modelValidations.province"
                      autocomplete="off"
                      filterable
                      name="province"
                      placeholder="Provincia"
                      @change="clearCity"
                    >
                      <el-option
                        v-for="option in provincesOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>

                    <small v-show="province.invalid" class="text-danger">
                      {{ getError('province') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label d-block"> Localidad (*) </label>

                    <el-autocomplete
                      v-model="formData.cityName"
                      v-validate="modelValidations.city"
                      :disabled="!formData.province"
                      name="city"
                      class="w-100"
                      placeholder="Localidad"
                      :fetch-suggestions="querySearchAsync"
                      @select="selectCity"
                    >
                    </el-autocomplete>

                    <small v-show="city.invalid" class="text-danger d-block">
                      {{ getError('city') }}
                    </small>

                    <small v-show="searchError !== ''" class="text-danger d-block">
                      {{ searchError }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Actividad </label>

                    <el-select
                      v-model="formData.activity"
                      v-validate="modelValidations.activity"
                      autocomplete="off"
                      filterable
                      name="activity"
                      placeholder="Seleccione Actividad Realizada"
                    >
                      <el-option
                        v-for="option in activitiesOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>

                    <small v-show="activity.invalid" class="text-danger">
                      {{ getError('activity') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Latitud </label>

                    <el-input
                      v-model="formData.latitude"
                      v-validate="modelValidations.latitude"
                      :disabled="true"
                      name="latitude"
                      placeholder="Latitud"
                    >
                    </el-input>

                    <small v-show="latitude.invalid" class="text-danger">
                      {{ getError('latitude') }}
                    </small>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label"> Longitud </label>

                    <el-input
                      v-model="formData.longitude"
                      v-validate="modelValidations.longitude"
                      :disabled="true"
                      name="longitude"
                      placeholder="Longitud"
                    >
                    </el-input>

                    <small v-show="longitude.invalid" class="text-danger">
                      {{ getError('longitude') }}
                    </small>
                  </div>
                </div>

                <div class="col-md-12 text-right">
                  <base-button native-type="submit" type="primary">Guardar</base-button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-6">
            <field-map
              map-id="field-map"
              :zoom="6"
              entity-type="campo"
              :entity="formData"
              :latitude.sync="formData.latitude"
              :longitude.sync="formData.longitude"
              :title="field.name"
              :default-lat="formData.latitude"
              :default-lng="formData.longitude"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Autocomplete } from 'element-ui';
import cityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import { mapFields } from 'vee-validate';
import ProducerSelect from '../../../components/ModelSelects/ProducerSelect';
import FieldMap from '@/views/Plots/Widgets/Map';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    ProducerSelect,
    FieldMap,
  },

  mixins: [cityProvinceOptionsMixin],
  props: {
    field: {
      type: Object,
      default: () => {
        return {
          name: null,
          producer: null,
          province: null,
          city: null,
          hectares: null,
          address: '',
          latitude: null,
          longitude: null,
          activity: null,
        };
      },
    },

    editMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      validated: false,
      title: '',
      formData: {
        name: this.field.name,
        producer: this.field.producer,
        province: this.field.province,
        city: null,
        cityName: null,
        hectares: this.field.hectares,
        address: this.field.address,
        latitude: this.field.latitude,
        longitude: this.field.longitude,
        activity: this.field.activity,
      },

      modelValidations: {
        name: {
          required: true,
          min: 5,
        },

        producer: {
          required: true,
        },

        province: {
          required: true,
        },

        city: {
          required: true,
        },

        address: {
          required: true,
        },

        hectares: {
          required: true,
        },

        latitude: {},
        longitude: {},
        activity: {},
      },
    };
  },

  computed: {
    ...mapFields(['name', 'producer', 'province', 'city', 'hectares', 'address', 'latitude', 'longitude', 'activity']),
    activitiesOptions() {
      return this.fetchActivities();
    },
  },

  mounted() {
    if (this.field.city) {
      this.defaultCity = this.field.city.id;
      this.defaultCityName = this.field.city.name;
      this.defaultProvince = this.field.city.province.id;
    }
    this.setTitle();
  },

  methods: {
    fetchActivities() {
      return [
        {
          value: 'Agrícola',
          label: 'Agrícola',
        },
        {
          value: 'Ganadera',
          label: 'Ganadera',
        },
        {
          value: 'Tambo',
          label: 'Tambo',
        },
      ];
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    setTitle() {
      if (this.editMode) {
        this.title = 'Editar Campo - Productor: ' + this.field.producer.businessName;
      } else {
        this.title = 'Agregar un nuevo campo';
      }
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
